module.exports = __webpack_public_path__ + "img/img10.324cffb7.svg";